import { render, staticRenderFns } from "./SubmitMatchVod.vue?vue&type=template&id=a2bb45ae&"
import script from "./SubmitMatchVod.vue?vue&type=script&lang=js&"
export * from "./SubmitMatchVod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports